var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCimNohDifficileFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #ebeca0;\n      }\n\n      .st2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st3 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st4 {\n        fill: #215d64;\n      }\n\n      .st5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 50.9,
    y: 49.9,
    width: 68.4,
    height: 70.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,93.1c0,15,12.2,27.1,27.1,27.1s27.1-12.2,27.1-27.1-12.2-27.1-27.1-27.1-27.1,12.2-27.1,27.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 50.9,
    y: 49.9,
    width: 68.4,
    height: 70.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.5,93.1c0-15,12.2-27.1,27.1-27.1s27.1,12.2,27.1,27.1-12.2,27.1-27.1,27.1-27.1-12.2-27.1-27.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,83.3l-5.6,6.7c-.5.5-1.3.5-1.7-.1l-4.3-7.5c-.4-.7-1.4-.7-1.8,0l-4.4,7.6c-.4.6-1.2.7-1.7.1l-5.8-6.9c-.6-.8-1.9-.3-1.8.7l1.6,19.4c0,.5.5.9,1,.9h23.5c.5,0,1-.4,1-.9l1.6-19.4c0-1-1.2-1.5-1.8-.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.7,67.9c.3.3.6.3.9,0l.4-.3c.3-.3.3-.6,0-.9l-3.3-3.8c-.3-.3-.6-.3-.9,0l-6.2,5.3c-.3.3-.3.6,0,.9l3.3,3.8c.3.3.6.3.9,0l.4-.3c.3-.3.3-.6,0-.9l-2.4-2.7,1.5-1.3,2,2.3c.3.3.6.3.9,0l.3-.2c.3-.3.3-.6,0-.9l-2-2.3,1.6-1.4,2.4,2.7ZM102.4,64.3l4.2,3c.3.2.7.2.9-.1l.3-.4c.2-.3.2-.7-.2-.9l-2.9-2.1,4.1-5.7c.2-.3.2-.7-.2-.9l-.7-.5c-.3-.2-.7-.2-.9.1l-4.7,6.6c-.2.3-.2.7.2.9M98.4,62.2l.8.3c.4.2.7,0,.9-.3l3.4-7.4c.2-.4,0-.7-.3-.9l-.8-.3c-.4-.2-.7,0-.9.3l-3.4,7.4c-.2.4,0,.7.3.9M93.2,60.5c1.2.3,2.2.1,3.1-.2.3-.1.4-.4.3-.8l-.2-.5c-.2-.4-.4-.5-.9-.3-.6.2-1.3.2-1.8,0-1.8-.4-2.7-2-2.3-3.6.4-1.6,1.8-2.7,3.6-2.2.6.1,1.2.4,1.6.9.3.3.6.4.9,0l.4-.3c.3-.3.3-.6,0-.9-.6-.7-1.4-1.2-2.6-1.5-3.1-.7-5.6,1-6.1,3.6-.6,2.6.8,5.2,4,5.9M84.9,59.3h.8c.4,0,.7-.2.7-.6l.2-8.2c0-.4-.2-.7-.6-.7h-.8c-.4,0-.7.2-.7.6l-.2,8.2c0,.4.2.7.6.7M80.3,50l-5,.9c-.4,0-.6.3-.5.8l1.4,8c0,.4.4.6.8.5h.8c.4-.2.6-.5.5-.9l-.6-3.1,3-.5c.4,0,.6-.4.5-.8v-.4c-.1-.4-.4-.6-.8-.5l-3,.5-.4-2.1,3.6-.6c.4,0,.6-.3.5-.8v-.5c-.2-.4-.4-.6-.8-.5M70.2,52.2l-4.7,2.1c-.4.2-.5.5-.3.9l3.4,7.4c.2.4.5.5.9.3l.8-.3c.4-.2.5-.5.3-.9l-1.3-2.9,2.8-1.3c.4-.2.5-.5.3-.9v-.3c-.3-.4-.6-.5-1-.3l-2.8,1.3-.9-1.9,3.3-1.5c.4-.2.5-.5.3-.9l-.2-.5c-.2-.4-.5-.5-.9-.3M65.6,65.2l.7-.5c.4-.2.4-.5.2-.9l-4.4-6.9c-.2-.4-.5-.4-.9-.2l-.7.5c-.4.2-.4.5-.2.9l4.4,6.9c.2.4.6.4.9.2M57.6,69.9l-4.2-4,1-1c1.2-1.3,2.9-1.2,4.1,0,1.2,1.2,1.4,2.8.1,4.1l-1,1ZM57.9,72.2l2.2-2.3c2-2.1,1.8-5,0-6.8-1.9-1.8-4.8-1.8-6.8.2l-2.2,2.3c-.3.3-.3.6,0,.9l5.9,5.6c.3.3.6.3.9,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimNohDifficileFr);
export default __webpack_public_path__ + "static/media/cim_noh_difficile_fr.6b206975bc39df26d957482197179fca.svg";
export { ForwardRef as ReactComponent };